import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=270a00d2&scoped=true"
import script from "./LoginOtp.vue?vue&type=script&lang=js"
export * from "./LoginOtp.vue?vue&type=script&lang=js"
import style0 from "./LoginOtp.vue?vue&type=style&index=0&id=270a00d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a00d2",
  null
  
)

export default component.exports